import { useContext } from "react";
import { CartContext } from "../contexts/cartContext";

export const useCart = () => {
  const context = useContext(CartContext);

  return context;
};
